import React from "react";
import { Button } from "reactstrap";
import styles from "./Finalize.module.scss";
import { useNavigate } from "react-router-dom";
import ScrollToTop from "../../../components/common/ScrollToTop/ScrollToTop";

const Finalize = () => {
  const navigate = useNavigate();

  const data = [
    { field: "Your Name", value: "None" },
    { field: "Phone", value: "None" },
    { field: "Email", value: "None" },
    { field: "Country/State", value: "None" },
    { field: "City", value: "None" },
    { field: "Address", value: "None" },
    { field: "ZIP", value: "None" },
    { field: "Payment Method", value: "None" },
    { field: "Card no/account no.", value: "None" },
    { field: "Expiration date", value: "None" },
    { field: "Card/account holder name", value: "None" },
  ];

  const handlePlaceOrder = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    navigate("/checkout/order-placed");
  };

  return (
    <div className={styles.mainFinalizeContainer}>
      <ScrollToTop />

      <p className={styles.checkDetailsText}>Final check the details and place order</p>
      <table className="table table-striped">
        <tbody>
          {data.map((item) => (
            <tr>
              <td>{item.field}:</td>
              <td className={styles.valueData}>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Button color="link" className={styles.editBtn}>Edit</Button>

      <div className={styles.placeOrderBtnContainer}>
        <Button
          color="info"
          className={styles.orderPlaceBtn}
          onClick={() => handlePlaceOrder()}
        >
          Place Order
        </Button>
      </div>
    </div>
  );
};

export default Finalize;